export default __webpack_public_path__ + "static/media/admin_product_content.85c239a3.svg";